module.exports = __webpack_public_path__ + "img/loading.2ef57216.gif";